import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { BreadCrumbs as BreadCrumbsComponent } from '@beef/ui-kit';
import { compose } from '@beef/utils';
import { getIsRenderBreadcrumbs } from "../../store/blocks/heading/selectors";
import { getBreadcrumbsData } from "../../store/shared/selectors";
var mapStateToProps = function mapStateToProps(state) {
  return {
    path: getBreadcrumbsData(state),
    shouldRender: getIsRenderBreadcrumbs(state)
  };
};
export var Breadcrumbs = compose(connect(mapStateToProps), withRenderFlag)(BreadCrumbsComponent);